import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import NavMenu from "../../components/createForm/SchoolBusNavMenu";
import SchoolDashboardDatas from "../../components/dashboard/SchoolDashboard";
import { Box } from "@mui/material";
import "../../components/dashboard/Dashboard.css";

export default function Dashboard() {
  return (
    <Box className="dashboard-page-shell">
      <Box className="dashboard-page-shell-content">
        <TitleBar />
        <NavMenu />
        <SchoolDashboardDatas dashboard />
      </Box>
      <Footer />
    </Box>
  );
}
